// LinkedIn was removed from Simple Icons (trademark) — use FA6 for it.
import { FaComment, FaLinkedinIn, FaNewspaper, FaRegStar } from 'react-icons/fa6';
import {
  SiApple,
  SiFacebook,
  SiGoogle,
  SiInstagram,
  SiReddit,
  SiTripadvisor,
  SiX,
  SiYelp,
} from 'react-icons/si';

// Official brand marks per source type, in brand colors. Brand icons come
// from Simple Icons (react-icons/si); generic ones from Font Awesome 6.
const ICONS = {
  google_review: { Icon: SiGoogle, color: '#4285F4' },
  facebook_review: { Icon: SiFacebook, color: '#1877F2' },
  facebook_post: { Icon: SiFacebook, color: '#1877F2' },
  twitter: { Icon: SiX, color: '#000000' },
  instagram: { Icon: SiInstagram, color: '#E4405F' },
  linkedin: { Icon: FaLinkedinIn, color: '#0A66C2' },
  yelp_review: { Icon: SiYelp, color: '#D32323' },
  reddit: { Icon: SiReddit, color: '#FF4500' },
  tripadvisor_review: { Icon: SiTripadvisor, color: '#34E0A1' },
  applemaps_review: { Icon: SiApple, color: '#000000' },
  news: { Icon: FaNewspaper, color: '#718096' },
  blog: { Icon: FaNewspaper, color: '#718096' },
  other_review: { Icon: FaRegStar, color: '#D69E2E' },
  social_other: { Icon: FaComment, color: '#718096' },
};

export default function SourceIcon({ type, size = 15 }) {
  const { Icon, color } = ICONS[type] || { Icon: FaComment, color: '#718096' };
  return (
    <Icon size={size} color={color} aria-hidden="true" style={{ verticalAlign: '-2px' }} />
  );
}
